<template>
  <div
    class="brand-logo-mark"
    :class="[
      `brand-logo-mark--${variant}`,
      { 'brand-logo-mark--on-dark': onDark },
    ]"
  >
    <img :src="logoUrl" :alt="logoAlt" class="brand-logo-mark__icon" />
    <span v-if="showCaption" class="brand-logo-mark__caption">{{ logoCaption }}</span>
  </div>
</template>

<script setup>
defineProps({
  logoUrl: { type: String, required: true },
  logoCaption: { type: String, default: '杰门科技' },
  logoAlt: { type: String, default: 'DMe' },
  /** sm 侧栏 | md 登录页 | lg 大屏登录 */
  variant: { type: String, default: 'md' },
  showCaption: { type: Boolean, default: true },
  onDark: { type: Boolean, default: false },
})
</script>
